import React from 'react'

import { getBoxSplit } from '../../../module/utils'
import Button from '../Button/Button'
import ProgressBar from '../ProgressBar/ProgressBar'

import {
  WorkoutCompletionContainer,
  Title,
  SecondaryTitle,
  CounterDisplay,
  ProgressDisplayContainer,
  ButtonContainer,
} from './WorkoutCompletion-styled'

export default ({ title, action, actionTitle, counter, progress }) => {
  const { boxSpread } = progress
  const boxSplit = getBoxSplit({ boxSpread })
  return (
    <WorkoutCompletionContainer>
      <Title>{title}</Title>
      <SecondaryTitle>COMPLETE!</SecondaryTitle>
      <CounterDisplay>{counter}</CounterDisplay>
      <ProgressDisplayContainer>
        <ProgressBar target={progress.questionCount} split={boxSplit} animateOnEntry />
      </ProgressDisplayContainer>
      <ButtonContainer>
        <Button title={actionTitle} onClick={action} large />
      </ButtonContainer>
    </WorkoutCompletionContainer>
  )
}



// WEBPACK FOOTER //
// ./src/component/_presentational/WorkoutCompletion/WorkoutCompletion.jsx